import { CommonResponse } from '@/types';
import { httpRequest } from '@/utils/request';

export function getDeviceOverview() {
  return httpRequest<
    any,
    CommonResponse<
      {
        id: string;
        name: string;
        containerName: string;
        runStatus: number; // 2 表示停止、1表示 启动
        deviceCount: number;
        deviceOnlineCount: number;
        deviceOfflineCount: number;
      }[]
    >
  >({
    url: '/api/v1/device-service/overview',
  });
}

export function getDeviceMessage(data: { id: string }) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/monitor/service-message',
    method: 'POST',
    data,
  });
}
